import { Col, Row } from 'antd';
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './VerticalSection.module.scss';
import Text from '../../Atoms/Text';
import 'antd/es/row/style/css';
import 'antd/es/col/style/css';
import { TVerticalSectionProps } from './definitions';

import ScrollBottomIndicator from '../../../../../images/scroll-bottom-indicator.png';
import ScrollTopIndicator from '../../../../../images/scroll-top-indicator.png';
import ScrollTopDisabledIndicator from '../../../../../images/scroll-top-indicator-disabled.png';
import ScrollBottomDisabledIndicator from '../../../../../images/scroll-bottom-indicator.png';
import Image from '../../Atoms/Image';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

const VerticalSection: React.FC<TVerticalSectionProps> = ({
  title,
  subTitle,
  actionText,
  children,
  onAction,
}) => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [scrollValue, setScrollValue] = React.useState(0);
  const [scrollHeight, setScrollHeight] = React.useState(496);

  const { isMobileView } = useGetViewType();

  const isAtTop = React.useMemo(() => scrollValue === 0, [scrollValue]);

  const isAtBottom = React.useMemo(
    () => scrollValue + 495 >= scrollHeight,
    [scrollHeight, scrollValue],
  );

  const onScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    setScrollValue(e.currentTarget.scrollTop);
    setScrollHeight(e.currentTarget.scrollHeight);
  };

  const onPressScrollBottom = () => {
    if (isAtBottom) return;
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollValue + 400,
        behavior: 'smooth',
      });
    }
  };

  const onPressScrollTop = () => {
    if (isAtTop) return;
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollValue - 400,
        behavior: 'smooth',
      });
    }
  };

  const backToTop = () => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      ref={scrollRef}
      onScroll={onScroll}
      className={Styles['vertical-section']}
    >
      <Row justify="center" align="middle" style={{ zIndex: 2 }}>
        <Col>
          <Text variant="black" level={6}>
            <Text className={Styles['title']}>{title}</Text>{' '}
            {subTitle && <Text className={Styles['subtitle']}>{subTitle}</Text>}
          </Text>
        </Col>
      </Row>
      <Row
        justify="center"
        align="middle"
        className={Styles['action-text-container']}
        style={{ zIndex: 2 }}
      >
        <Col>
          <Text
            variant="black"
            onClick={onAction}
            className={Styles['action-text']}
          >
            {actionText}
          </Text>
        </Col>
      </Row>
      {!isMobileView && (
        <div className={Styles['scroller-container']}>
          <Image
            src={isAtTop ? ScrollTopDisabledIndicator : ScrollTopIndicator}
            className={Styles['scroll-img']}
            onClick={onPressScrollTop}
          />
          <Image
            src={
              isAtBottom ? ScrollBottomDisabledIndicator : ScrollBottomIndicator
            }
            className={Styles['scroll-img']}
            onClick={onPressScrollBottom}
          />
        </div>
      )}
      <Row>
        {children}
        <div className={Styles['back-to-top-container']} onClick={backToTop}>
          <Text className={Styles['back-to-top-txt']}>Back to top</Text>
        </div>
      </Row>
    </div>
  );
};

export default VerticalSection;
